import { render, staticRenderFns } from "./MobileMore.vue?vue&type=template&id=2cb8b265&scoped=true"
import script from "./MobileMore.vue?vue&type=script&lang=js"
export * from "./MobileMore.vue?vue&type=script&lang=js"
import style0 from "./MobileMore.vue?vue&type=style&index=0&id=2cb8b265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8b265",
  null
  
)

export default component.exports